// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-common-ConfirmationOnErrorModal-module__root--3b6MX"};